<template>
  <div>
    <b-input-group class="mt-1">
                  <b-input v-model="filter" placeholder="Busque um produto...." @keyup="$emit('search',filter)"></b-input>
                  <b-input-group-append>
        <b-button variant="" @click="cleanSearch">Limpar</b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  data(){
    return {
      filter:""
    }
  },
  methods:{
    cleanSearch(){
      this.filter=""
      this.$emit('clean',"")
    }
  }

}
</script>

<style>

</style>